import AlpineInstance from "alpinejs";

export default () => ({
  open: false,
  heightSet: false,
  showLoading: false,

  hide() {
    this.open = false;
    this.$refs.quickAddInfo.innerHTML = "";
  },

  show(productUrl) {
    Alpine.store('shopTheLookState').set(true);
    Alpine.store('quickShopSource').set('modal');

    if(!document.body.classList.contains('body-outfit-pdp')) {
      document.body.classList.add('body-outfit-pdp');
    }

    this.open = true;
    this.showLoading = true;

    fetch(productUrl)
      .then((response) => response.text())
      .then((responseText) => {

        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('div[id^="ShopTheLook-"]');
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        this.setInnerHTML(this.$refs.quickAddInfo, this.productElement.innerHTML);
        this.showLoading = false;


        if (window.Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }

        if (window.ProductModel) window.ProductModel.loadShopifyXR();
      })
      .finally(() => {
        // loading
      });
  },

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
    this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
      variantSelect.dataset.originalSection = sectionId;
    });
  },

  removeDOMElements() {
    const pickupAvailability = this.productElement.querySelector('pickup-availability');
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = this.productElement.querySelector('product-modal');
    if (productModal) productModal.remove();
  },

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  },

  toggleBodyClass() {
    document.querySelector('body').classList.toggle('modal-open');
  }
});